import { VscCalendar, VscDashboard, VscFileBinary, VscSymbolBoolean, VscSymbolClass, VscSymbolEnum, VscSymbolKey } from "react-icons/vsc";
import { BacnetObjectTypes } from "../../services/mapping/bacnet";
import { IoCalendarOutline } from "react-icons/io5";


export const BacnetObjectIcon = (props: { type: BacnetObjectTypes }) => {
    const { type } = props;
    if (type === BacnetObjectTypes.BINARY_INPUT ||
        type === BacnetObjectTypes.BINARY_OUTPUT ||
        type === BacnetObjectTypes.BINARY_VALUE)
        return (<VscSymbolBoolean></VscSymbolBoolean>)

    if (type === BacnetObjectTypes.CALENDAR)
        return (<VscCalendar></VscCalendar>)

    if (type === BacnetObjectTypes.ANALOG_INPUT ||
        type === BacnetObjectTypes.ANALOG_OUTPUT ||
        type === BacnetObjectTypes.ANALOG_VALUE
    )
        return (<VscDashboard />)

    if (type === BacnetObjectTypes.MULTI_STATE_INPUT ||
        type === BacnetObjectTypes.MULTI_STATE_OUTPUT ||
        type === BacnetObjectTypes.MULTI_STATE_VALUE
    )
        return (<VscSymbolEnum />)

        if ( type === BacnetObjectTypes.SCHEDULE)
        return (<IoCalendarOutline></IoCalendarOutline>)

        if (type === BacnetObjectTypes.CHARACTERSTRING_VALUE        )
            return (<VscSymbolKey />)

    return (<VscSymbolClass></VscSymbolClass>)
}

